import Formulario from './view/Formulario.vue'
import Graficos from './view/Graficos.vue'
import Home from './view/Home.vue'
import Login from './view/Login.vue'
import Settings from './view/Settings.vue'
import About from './view/About.vue'

export const routes = [
{path:'/', component: Login},
{path:'/home', component: Home},
{path: '/simulation/:code', component: Formulario},
{path:'/graficos/:code', component: Graficos},
{path:'/settings', component: Settings},
{path:'/about', component: About},
];